var arrowPath = 'M37.0607 13.0607C37.6464 12.4749 37.6464 11.5251 37.0607 10.9393L27.5147 1.39339C26.9289 0.807608 25.9792 0.807608 25.3934 1.3934C24.8076 1.97918 24.8076 2.92893 25.3934 3.51472L33.8787 12L25.3934 20.4853C24.8076 21.0711 24.8076 22.0208 25.3934 22.6066C25.9792 23.1924 26.9289 23.1924 27.5147 22.6066L37.0607 13.0607ZM9.26192e-08 13.5L36 13.5L36 10.5L-9.26192e-08 10.5L9.26192e-08 13.5Z';

class CustomSlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    const isAutoplay = this.getAttribute('data-autoplay');
    console.log('autoplay', isAutoplay);
    if (isAutoplay == "true") {
      console.log('true', isAutoplay);
      var splide = new Splide(this.querySelector('.splide'), {
        type: 'loop',
        perPage: 1,
        autoplay: true,
        arrowPath: arrowPath,
        interval: this.getAttribute('data-splide-interval'),
      });

      splide.mount();
      const thisEle = this;
      // setInterval(function() {
      //   splide.go('>');
      // }, 3000);
    }
    else {
      console.log('false', isAutoplay);
      var splide = new Splide(this.querySelector('.splide'), {
        type: 'loop',
        perPage: 1,
        arrowPath: arrowPath
      });

      splide.mount();

    }
  }

}

customElements.define('custom-slideshow-component', CustomSlideshowComponent);


class CustomCategoriesComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    var arrowPath = 'M36.3536 4.35355C36.5488 4.15829 36.5488 3.8417 36.3536 3.64644L33.1716 0.464462C32.9763 0.2692 32.6597 0.2692 32.4645 0.464462C32.2692 0.659724 32.2692 0.976307 32.4645 1.17157L35.2929 4L32.4645 6.82842C32.2692 7.02369 32.2692 7.34027 32.4645 7.53553C32.6597 7.73079 32.9763 7.73079 33.1716 7.53553L36.3536 4.35355ZM3.08731e-08 4.5L36 4.5L36 3.5L-3.08731e-08 3.5L3.08731e-08 4.5Z';
    var splide = new Splide(this.querySelector('.splide'), {
      perPage: 6,
      gap: 30,
      arrowPath: arrowPath,
      breakpoints: {
        989: {
          perPage: 3,
          gap: 5
        },
      }
    });

    splide.mount();
  }

}

customElements.define('categories-slide', CustomCategoriesComponent);


class CustomSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    var arrows = true;
    if (this.querySelector('.slider--mobile').classList.contains('style_2')) {
      arrows = false;
    }
    var arrowPath = 'M36.3536 4.35355C36.5488 4.15829 36.5488 3.8417 36.3536 3.64644L33.1716 0.464462C32.9763 0.2692 32.6597 0.2692 32.4645 0.464462C32.2692 0.659724 32.2692 0.976307 32.4645 1.17157L35.2929 4L32.4645 6.82842C32.2692 7.02369 32.2692 7.34027 32.4645 7.53553C32.6597 7.73079 32.9763 7.73079 33.1716 7.53553L36.3536 4.35355ZM3.08731e-08 4.5L36 4.5L36 3.5L-3.08731e-08 3.5L3.08731e-08 4.5Z';
    if (window.innerWidth < 989) {
      var splide = new Splide(this.querySelector('.slider--mobile'), {
        type: 'loop',
        perPage: 1,
        arrowPath: arrowPath,
        breakpoints: {
          989: {
            arrows: arrows
          }
        }
      });

      var linksplide = new Splide(this.querySelector('.splide-tab'), {
        type: 'loop',
        perPage: 3,
        isNavigation: true,
        pagination: false,
        arrows: false,
        gap: 30,
        focus: 'center',
        breakpoints: {
          989: {
            arrows: false
          }
        }
      });
      splide.sync(linksplide);
      splide.mount();
      linksplide.mount();
    }

  }

}

customElements.define('custom-slider-component', CustomSliderComponent);

class CustomBlogCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    var desktopColumns = this.querySelector('.splide').dataset.columns;
    console.log(desktopColumns)
    var imageSplide = new Splide(this.querySelector('.splide'), {
      perPage: desktopColumns,
      perMove: 1,
      pagination: false,
      arrows: false,
      gap: 20,
      breakpoints: {
        989: {
          perPage: 2,
          perMove: 1,
          rewind: true,
          gap: 20,
          pagination: true,
          arrows: true
        },
        749: {
          perPage: 1,
          perMove: 1,
          rewind: true,
          gap: 0,
          pagination: true,
          arrows: true
        }
      }
    });
    imageSplide.mount();
  }
}

customElements.define('blog-carousel', CustomBlogCarouselComponent);


function swymCallbackFn(swat) {
  // your API calls go here
  document.addEventListener("swym:collections-loaded", function () {
    const intervalId = setInterval(function () {
      if ($('.swym-button.swym-add-to-wishlist-view-product').length > 0) {
        $('.swym-button.swym-add-to-wishlist-view-product').each(function() {
          const $this = $(this);
          swat.wishlist.getSocialCount({empi: $(this).data('product-id')}, function (resp) {
            if (resp && resp.data && resp.data.count > 0) {
              $this.html('<span class="favorite_count">' + resp.data.count + '</span>');
            }
          }, function(error) {
            $this.html('');
            console.log("Error while fetching social count", error);  
          });
        });
        clearInterval(intervalId);
      }
    }, 100);
    swat.initializeActionButtons("#ProductGridContainer");
  });

  document.addEventListener("swym:recommendation-loaded", function () {
    swat.initializeActionButtons("#product-recommendation");
  });

  swat.evtLayer.addEventListener('sw:addedtowishlist', function (e) {
    var data = e.detail.d;
	console.log("YAY! Added the product to wishlist", data);
    const $this = $(".swym-add-to-wishlist-view-product[data-product-id='" + data.empi + "']");
    swat.wishlist.getSocialCount({empi: data.empi}, function (resp) {
      if (resp && resp.data && resp.data.count > 0) {
        $this.html('<span class="favorite_count">' + resp.data.count + '</span>');
      }
    }, function(error) {
      $this.html('');
      console.log("Error while fetching social count", error);  
    });
  });

  swat.evtLayer.addEventListener('sw:addedtocart', function (e) {
    var data = e.detail.d.productData;
    console.log("YAY! Added to cart", e);
    var cart = document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`/?sections=${cart.getSectionsToRender().map((section) => section.id)}`)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        var render_data = {
          id: data.id,
          sections: response
        }
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(render_data);
      });
  });

  const intervalId = setInterval(function () {
    if ($('.swym-button.swym-add-to-wishlist-view-product').length > 0) {
      $('.swym-button.swym-add-to-wishlist-view-product').each(function() {
        const $this = $(this);
        swat.wishlist.getSocialCount({empi: $(this).data('product-id')}, function (resp) {
          if (resp && resp.data && resp.data.count > 0) {
            $this.html('<span class="favorite_count">' + resp.data.count + '</span>');
          }
        }, function(error) {
          $this.html('');
          console.log("Error while fetching social count", error);  
        });
      });
      clearInterval(intervalId);
    }
  }, 100);

  // $(".swym-button.swym-add-to-wishlist-view-product").click(function () {
  //   console.log("wishlist button clicked")
  //   const timeoutId = setInterval(() => {
  //     const $this = $(this);
  //     swat.wishlist.getSocialCount({empi: $(this).data('product-id')}, function (resp) {
  //       $this.html('<span class="favorite_count">' + resp.data.count + '</span>');
  //     }, function(error) {
  //       $this.html('<span class="favorite_count">0</span>');
  //       console.log("Error while fetching social count", error);  
  //     });
  //   }, 100);

  //   setTimeout(() => {
  //     clearInterval(timeoutId);
  //   }, 3000);
  // });
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

function scrollToTopOfElement(elementId) {
  const element = document.getElementById(elementId);

  if (element) {
    const rect = element.getBoundingClientRect();
    const width = window.innerWidth;
    if (width >= 768) {
      window.scroll(0, rect.top + window.scrollY);
    } else {
      window.scroll(0, rect.top + window.scrollY - 200);
    }
  }
}

document.querySelectorAll('a').forEach(btn => {
  btn.addEventListener('click', function (e) {
    var href = btn.getAttribute('href') ?? '';
    if (href.includes('#/')) {
      location.href = href;
      location.reload();
    } else {
      if (href.indexOf('#') == 0) {
        e.preventDefault();
        console.log(href.replace('#', ''))
        scrollToTopOfElement(href.replace('#', ''));
      }
    }
  });
});

if (document.querySelector('.footer_button')) {
  document.querySelector('.footer_button').addEventListener('click', function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RNUUJW']);
  });
}

if (document.querySelector('#collections__back-to-top')) {
  const u = document.querySelector('#collections__back-to-top');
  if (u) {
    var f = window.innerHeight;
    window.addEventListener("scroll", function () {
      var e = window.scrollY || window.pageYOffset;
      e > f && !jQuery(u).hasClass("is-visible") ? u.classList.add("is-visible") : e <= f && jQuery(u).hasClass("is-visible") && u.classList.remove("is-visible")
    });
    u.addEventListener("click", (function () {
      if (window.innerWidth < 900) {
        document.querySelector('[data-sticky-type="on-scroll-up"].header-wrapper').classList.remove('p-sticky');
        document.querySelector('#MainContent').classList.remove('p-sticky');
      }
      window.scrollTo(0, 0);
    }))
  }
}

// Function that runs at regular intervals
const intervalId = setInterval(() => {
  // console.log("---------------------------SETINVERTAL--------------------------------");
  // Your code here

  if (document.querySelector('.customer.account .wishlist-content .swym-variant-title')) {

    // Clear the interval to stop the function from running
    clearInterval(intervalId);
    // console.log("---------------------------CLEARINTERVAL--------------------------------");
    // console.log($('.customer.account .wishlist-content .swym-variant-title').html())

    $('.customer.account .wishlist-content .swym-variant-title').each(function() {
      if($(this).html() == ''){
        $(this).css('display', 'none');
      }
    });
  }

  // $('.customer.account .wishlist-content .swym-variant-title').html()
}, 500);

window.addEventListener("pageshow", (event) => {
  setTimeout(function(){
    var cart = document.querySelector('cart-drawer');

    fetch(`/?sections=${cart.getSectionsToRender().map((section) => section.id)}`)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        var render_data = {
          id: '',
          sections: response
        }

        cart.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          sectionElement.innerHTML = cart.getSectionInnerHTML(render_data.sections[section.id], section.selector);
        });
        if(cart.querySelectorAll('.drawer__inner-empty').length > 0) {
          cart.classList.add('is-empty');
        } else if (cart && cart.classList.contains("is-empty") && render_data) {
          cart.classList.remove("is-empty");
        }
      });
    }, 100);
});